/*
 * Public API Surface of angular-components
 */
export * from './ac-pipe.module';
export * from './ac-dynamic.pipe';

